module.exports = __webpack_public_path__ + "image/about-nav.png";